<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <v-data-table-server
          v-model:options="options"
          dense
          :headers="headers"
          :loading="loading"
          :items="items"
          :items-length="totalItems"
          class="elevation-1"
          :items-per-page-options="footerProps.itemsPerPageOptions"
          @update:options="updateTable"
        >
          <template #top>
            <v-card-title>
              <v-toolbar flat>
                <v-toolbar-title>Action Log</v-toolbar-title>
              </v-toolbar>
            </v-card-title>
          </template>

          <template #item.created_at="{ item }">
            {{ createDate(item.created_at) }}
          </template>

          <template #item.causer="{ item }">
            <span v-if="item.causer">
              {{ item.causer.first_name }} {{ item.causer.last_name }}
            </span>
          </template>

          <template #item.subject_type="{ item }">
            {{ item.subject_type.split('\\').pop().split('/').pop() }}
          </template>

          <template #item.before="{ item }">
            <span v-if="Array.isArray(item.properties.old)">
              -
            </span>
            <v-btn
              v-else
              tile
              color="primary"
              small
              text
              @click="showJsonModal('JSON', item.properties.old)"
            >
              <v-icon
                dark
                left
                class="mr-1"
              >
                mdi-eye
              </v-icon>
              SHOW
            </v-btn>
          </template>

          <template #item.after="{ item }">
            <span v-if="Array.isArray(item.properties.attributes)">
              -
            </span>
            <v-btn
              v-else
              tile
              color="primary"
              small
              text
              @click="showJsonModal('JSON', item.properties.attributes)"
            >
              <v-icon
                dark
                left
                class="mr-1"
              >
                mdi-eye
              </v-icon>
              SHOW
            </v-btn>
          </template>
        </v-data-table-server>
      </v-col>
    </v-row>
    <JsonModal
      v-model="jsonModal"
      :title="jsonTitle"
      :json="json"
      @close-modal="closeJsonModal()"
      @click:outside="closeJsonModal()"
    />
  </v-container>
</template>

<script>
import { DateTime } from 'luxon';
import dataTableMixin from '@/mixins/dataTableMixin.js';
import JsonModal from '@/components/JsonModal.vue';

export default {
  name: 'LoanProCustomerProfile',
  components: {
    JsonModal,
  },
  mixins: [
    dataTableMixin,
  ],
  data() {
    return {
      json: {},
      jsonTitle: '',
      jsonModal: false,
      headers: [
        { title: 'Date/Time', key: 'created_at' },
        { title: 'Log', key: 'log_name' },
        { title: 'Admin', key: 'causer' },
        { title: 'Action', key: 'description' },
        { title: 'Model', key: 'subject_type' },
        { title: 'Model ID', key: 'subject_id' },
        { title: 'Before', key: 'before' },
        { title: 'After', key: 'after' },
      ],
    };
  },
  methods: {
    async updateTable() {
      this.loading = true;

      const response = await this.$axios
        .get(`api/v1/loanpro-customer/${this.$route.params.customer_id}/actions`, {
          params: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            ...this.sortParams,
            search: this.search,
          },
        });

      this.totalItems = response.data.total;
      this.items = response.data.data;
      this.loading = false;
    },
    createDate(date) {
      return DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_MED);
    },
    closeJsonModal() {
      this.jsonModal = false;
      this.$nextTick(() => {
        this.json = {};
      });
    },
    showJsonModal(title, json) {
      this.json = json;
      this.jsonTitle = title;
      this.jsonModal = true;
    },
  },
};
</script>
